'use strict';

module.exports = require('./components/inputs/Input').default;


//////////////////
// WEBPACK FOOTER
// ./~/coact/Input.js
// module id = 1903
// module chunks = 0